import { isEmpty, parseBig } from 'utilities';

/** Amount sign must match `type`. Validated against the current `type`, which the user can
 * correct in the dialog, not the extracted is_credit_note. Zero passes on either type.
 *
 * Only the extraction dialog runs this — the expense form does not pass a `validate` to TotalsFields,
 * and the serializer only checks that the alt/native pair is complete. So this guards model output,
 * not expenses in general. */
export const signedAmount = (value: any, allValues: any): string | undefined => {
  if (isEmpty(value)) {
    return 'This field is required';
  }
  const credit = allValues?.type === 'CREDIT';
  const n = parseBig(value);
  if (credit ? n.gt(0) : n.lt(0)) {
    return credit ? 'Credit note amounts are negative' : 'Invoice amounts are positive';
  }

  // VAT above the total flips the sign of sub_total, which is all the server checks. Compare the pair
  // TotalsFields is showing — on a foreign invoice that is the alt one.
  const foreign = !!allValues?.alt_currency;
  const totalValue = foreign ? allValues?.alt_total : allValues?.total;
  const vatValue = foreign ? allValues?.alt_vat_amount : allValues?.vat_amount;
  const subTotal = parseBig(totalValue).minus(parseBig(vatValue));
  if (!isEmpty(totalValue) && !isEmpty(vatValue) && (credit ? subTotal.gt(0) : subTotal.lt(0))) {
    return 'VAT amount exceeds the total';
  }
  return undefined;
};
